import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCardSaveActive = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 20,
			r: 20,
			fill: "url(#paint0_linear_706_106275)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5226 29.7956L14.4989 29.8196L14.4929 29.8269C14.4593 29.8531 14.435 29.8589 14.422 29.8606C14.406 29.8627 14.3729 29.8629 14.3212 29.8375C14.2587 29.7966 14.1333 29.6379 14.1333 29.3784V11.3945C14.1333 10.5591 14.6783 10.1333 15.0492 10.1333H24.7442C25.1151 10.1333 25.6602 10.5591 25.6602 11.3945V29.3526C25.6602 29.6212 25.5258 29.7818 25.4659 29.8156L25.4356 29.8328L25.4069 29.8525C25.3977 29.8588 25.3883 29.8632 25.3809 29.8657C25.3681 29.8632 25.338 29.8544 25.2971 29.8227L25.2945 29.8196L25.2708 29.7956L20.4662 24.926L19.8967 24.3489L19.3272 24.926L14.5226 29.7956Z",
			fill: "white",
			stroke: "white",
			strokeWidth: 1.6
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_706_106275",
			x1: 20,
			y1: 0,
			x2: 20,
			y2: 40,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF699C" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FE5763"
			})]
		}) })
	]
});
export default SvgCardSaveActive;
